// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bes_a bik_b bik_va bik_rv bik_rw bik_vu","PanelFooter--link":"bes_b"};